import DefaultValidation from "@/services/validations/DefaultValidation";
import { isNull } from "@/functions/Util";


export default class RentabilidadeValidation extends DefaultValidation {


    validate(model, refs) {
        

        let validated = true;

        Object.entries(model).forEach(([key, value]) => {
            if (value != null && typeof value == "string") model[key] = value.trim();
        });

        if (isNull(model.tipo)) {
            refs.tipoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.percentual)) {
            refs.percentualInput.focusedOut = true;
            validated = false;
        }

        if (isNull(model.idrentabilidadeerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}